<template>
  <b-container class="w-100 mt-5 mb-5 position-relative">
    <img
      ref="invisible-image"
      src="https://cdn.vexels.com/img/get-extra-graphics-top.png"
      :alt="$t('plans.design.getGraphics.extraGraphicsAlt')"
      class="invisible-top w-100"
      loading="lazy"
    />
    <img
      src="https://cdn.vexels.com/img/get-extra-graphics-top.png"
      :alt="$t('plans.design.getGraphics.extraGraphicsAlt')"
      class="visible-top w-100 position-absolute"
      :class="{ top }"
      loading="lazy"
    />
    <div class="title-container w-50 text-center position-absolute">
      <img
        src="https://cdn.vexels.com/img/gift.svg"
        :alt="$t('plans.design.getGraphics.giftIconAlt')"
        class="gift-icon"
        loading="lazy"
      />
      <h2 class="title">{{ $t(`${plansPage}.${getExperience}.getGraphics.title`) }}</h2>
      <h3 class="subtitle">{{ $t(`${plansPage}.${getExperience}.getGraphics.subtitle`) }}</h3>
    </div>
    <img
      src="https://cdn.vexels.com/img/get-extra-graphics-bottom.png"
      :alt="$t('plans.design.getGraphics.extraGraphicsAlt')"
      class="w-100 bottom-img"
      loading="lazy"
    />
    <div class="w-100 d-flex align-items-center mt-3">
      <Button shape="full" class="m-auto" @click="click">
        {{ $t(`${plansPage}.${getExperience}.getGraphics.btnText`) }}
      </Button>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from 'UI/Button';

export default {
  name: 'GetGraphics',
  components: {
    Button
  },
  props: {
    lifetime: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      top: false
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    plansPage() {
      return this.lifetime ? 'lifetimePlans' : 'plans';
    }
  },
  mounted() {
    window.addEventListener('scroll', this.topImageEffect);
    window.addEventListener('resize', this.topImageEffect);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.topImageEffect);
    window.removeEventListener('resize', this.topImageEffect);
  },
  methods: {
    topImageEffect() {
      const invisibleImage = this.$refs['invisible-image'],
        rect = invisibleImage.getBoundingClientRect(),
        windowHeight = window.innerHeight;
      if (rect.top - windowHeight / 2 <= 0 && !this.top) {
        this.top = true;
      } else if (rect.top - windowHeight / 2 > 0 && this.top) {
        this.top = false;
      }
    },
    click() {
      const options = {
        offset: -100
      };
      this.$scrollTo('.purchase-flow-container', 500, options);
    }
  }
};
</script>

<style lang="scss" scoped>
.invisible-top {
  opacity: 0;
}
.visible-top {
  left: 0;
  transition: top 0.7s;
  top: 35%;
}
.visible-top.top {
  top: 0;
}
.title-container {
  margin: auto;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.gift-icon {
  width: 30px;
}
.title {
  font-size: 35px;
  font-weight: 500;
  @include lg {
    font-size: 28px;
  }
  @include md {
    font-size: 20px;
  }
}
.subtitle {
  font-size: 18px;
  color: $defaultColor;
  font-weight: 400;
  @include lg {
    font-size: 15px;
  }
  @include md {
    font-size: 13px;
  }
}
.bottom-img {
  @include sm {
    margin-top: 50px;
  }
}
</style>
